import { useMediaQuery } from '@mui/material';
import { useEffect } from 'react';
import { rqx } from '../../../core/request/API';
import { env } from '../../../core/Env';
import { useState } from 'react';
import { List } from './List';
import { MList } from './MList';
// import { BizLogo } from '../../../core/global/Icons';

export const ToolCategories = ({ divID, navFeature, open, setOpen, redirectHandler, handleClickContactUs }) => {
    const mobile = useMediaQuery('(max-width:1024px)');
    const [tools, setTools] = useState([])
    const [loader, setLoader] = useState(false)
    
    const HandleClickTools = async(data) => {
        let str = data.abbreviation.toLowerCase()
        let slicedStr = str.replace("biz", ""); 
        let valURL = slicedStr === 'jobs' ? 'careers' : slicedStr === 'pms' ? 'paymeshare': slicedStr === 'sip'? 'sureipass' : slicedStr === 'ptb' ? 'teambond':slicedStr
        let url = `https://${env() === 'prod' ?'': env() === 'sb' ?'sb-':'dev-'}sales.pofsis.com/biz/${valURL}/index`
        try {
            window.open(url, '_blank').focus()
        } catch (error) {    
            window.location.href = url;
        }
    }

    const __init = async() => {
        setLoader(true)
        let res = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/tools/categories`, {filter: 2});
        if (res) {
            let data = []
            for (let i = 0; i < res.length; i++) {
                let res2 = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/tools/read`, {filter: 'category', platform:'business', tcid:res[i].id});
                data.push({tcid:res[i].id, name:res[i].name, tools:res2})
            }
            setTools(data)
            setLoader(false)
        }
    }

    useEffect(() => {
        let subscribe = true
        if (subscribe) {
            __init()
        }
        return () => subscribe = false;
        // eslint-disable-next-line
    }, [])

    return (
        mobile? 
            <MList divID={divID} navFeature={navFeature} open={open} setOpen={setOpen} loader={loader} tools={tools} redirectHandler={redirectHandler} HandleClickTools={HandleClickTools} handleClickContactUs={handleClickContactUs}/>
        :
            <List open={open} setOpen={setOpen} loader={loader} tools={tools} HandleClickTools={HandleClickTools}/>
    )
}